import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { BidService } from '../services/bid.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private isAuthenticated = false;
    private authSecretKey = 'BearerToken';

    constructor(
        private storageService: StorageService,
        private bidService: BidService,
    ) {
        this.isAuthenticated = !!localStorage.getItem(this.authSecretKey);
    }

    startSession(username: string): Observable<boolean> {
        let sendData = new Subject<boolean>();

        this.storageService.emptyStorage();

        this.bidService.startSession(username).subscribe((dataStart: any) => {
            console.log("dataStart: " + dataStart)
            this.getToken();

            this.storageService.getStorage('data').then((d: any) => {

                const data = JSON.parse(d.value);

                if (data.error === undefined) {
                    this.storageService.getStorage('TOKEN').then(authToken => {
                        this.storageService.getStorage('userId').then((op: any) => {
                            let userId = op.value;
                            console.log("userIdlogin", userId);
                            this.storageService.saveToStorage('userId', userId);
                            this.storageService.saveToStorage('TOKEN', authToken.value);

                            localStorage.setItem(this.authSecretKey, authToken.value);
                            this.isAuthenticated = true;
                            sendData.next(true)
                        });
                    });
                } else {
                    this.storageService.emptyStorage();
                    this.isAuthenticated = false;
                    sendData.next(false)
                }
            });
        }, error => {
            this.storageService.emptyStorage();
            this.isAuthenticated = false;
        
            sendData.next(error)
        });

        return sendData.asObservable()
    }

    login(email: string, pass: string): Observable<boolean> {
        let sendData = new Subject<boolean>();

        this.storageService.emptyStorage();

        this.bidService.login(email, pass).subscribe((data: any) => {
            this.getToken();


            this.storageService.getStorage('TOKEN').then(authToken => {
                this.storageService.getStorage('dataLogin').then(dataLogin => {

                    const resp = JSON.parse(dataLogin.value);
                    console.log(data);
                    if (resp.error === undefined) {
                        localStorage.setItem(this.authSecretKey, authToken.value);
                        this.isAuthenticated = true;
                        sendData.next(true)
                    } else {
                        this.storageService.emptyStorage();
                        this.isAuthenticated = false;
                        sendData.next(false)
                    }
                });
            });

        }, error => {
            this.storageService.emptyStorage();
            this.isAuthenticated = false;
            sendData.next(error)
        });

        return sendData.asObservable()
    }

    getToken() {
        this.bidService.getToken().subscribe((token: any) => {
            console.log("getToken", token.access_token);
            this.storageService.saveToStorage('TOKENJAVA', token.access_token);
            let sto = this.storageService.getStorage('TOKENJAVA');
            console.log("sto", sto);
        });
    }

    isAuthenticatedUser(): boolean {
        return this.isAuthenticated;
    }

    logout(): void {
        localStorage.removeItem(this.authSecretKey);
        this.storageService.emptyStorage();
        this.isAuthenticated = false;
    }
}